import { HashRouter } from 'react-router-dom';
import App from './App';
import React from 'react';
import { createRoot } from 'react-dom/client';

const getEnvUrls = () => {
  const hostname = window.location.hostname;
  let apiBase, uploadBase, webBase;

  if (hostname.includes("stagingsite.carloca.co.uk") || hostname.includes("staging")) {
    apiBase = "https://stagingsite.carloca.co.uk/apis/public/api";
    uploadBase = "https://stagingsite.carloca.co.uk/apis/public/uploads";
    webBase = "https://stagingsite.carloca.co.uk";
  } else if (hostname.includes("carloca.co.uk")) {
    apiBase = "https://carloca.co.uk/apis/public/api";
    uploadBase = "https://carloca.co.uk/apis/public/uploads";
    webBase = "https://carloca.co.uk";
  } else {
    apiBase = process.env.REACT_APP_API_URL || "http://localhost:8000/api";
    uploadBase = apiBase.replace("/api", "/uploads");
    webBase = "http://localhost:3000";
  }

  return { apiBase, uploadBase, webBase };
};

const urls = getEnvUrls();
window.CARLOCA_API = urls.apiBase;
window.CARLOCA_UPLOADS = urls.uploadBase;
window.CARLOCA_WEB = urls.webBase;
window.CARLOCA_PUBLIC = urls.apiBase.replace("/api", "");

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
